export default "__VITE_ASSET__DWuQ6SPn__"